import React from 'react';
import { Phone, Calendar } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-auto flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1596986952526-3be237187071?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxhdXRvJTIwcmVwYWlyJTIwc2hvcHxlbnwwfHx8fDE3NjUyNDM4NzJ8MA&ixlib=rb-4.1.0&q=85"
          alt="Auto Repair Shop"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/80 to-black"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-red-900/20 to-transparent"></div>
      </div>

      {/* Carbon Fiber Pattern Overlay */}
      <div className="absolute inset-0 z-0 carbon-fiber opacity-30"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Reliable Auto Repair &<br />
          <span className="text-red-600" style={{ textShadow: '0 0 20px rgba(255, 0, 0, 0.6)' }}>
            Maintenance
          </span>{' '}
          in Worcester
        </h1>
        
        <p className="text-xl sm:text-2xl text-white/85 mb-4 max-w-3xl mx-auto font-medium">
          Complete service, honest work, fair pricing
        </p>
        <p className="text-lg sm:text-xl text-white/70 mb-12 max-w-2xl mx-auto">
          Foreign & domestic vehicles
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <a
            href="tel:7742425144"
            className="flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white px-8 py-4 text-lg font-medium transition-all duration-300 hover:scale-105 w-full sm:w-auto min-w-[200px]"
            style={{ borderRadius: '0px', boxShadow: '0 0 30px rgba(255, 0, 0, 0.4)' }}
          >
            <Phone size={22} />
            Call Now
          </a>
          
          <button
            onClick={scrollToContact}
            className="flex items-center justify-center gap-3 bg-white/10 hover:bg-white hover:text-black text-white px-8 py-4 text-lg font-medium transition-all duration-300 border border-white/20 w-full sm:w-auto min-w-[200px]"
            style={{ borderRadius: '0px' }}
          >
            <Calendar size={22} />
            Book Appointment
          </button>
        </div>

        {/* Business Info */}
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-6 text-white/60 text-sm">
          <div className="flex items-center gap-2">
            <Phone size={16} />
            <span>(774) 242-5144</span>
          </div>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-white/40"></div>
          <span>522 SW Cutoff, Worcester, MA 01607</span>
        </div>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent z-10"></div>
    </section>
  );
};

export default HeroSection;